module.exports = __webpack_public_path__ + "static/img/banner3.32729ad4.png";